// Coralogix RUM SDK configuration
// These values are PUBLIC browser-side configuration, not secrets.
// See: https://coralogix.com/docs/browser-sdk-installation-guide/

export const CORALOGIX_PUBLIC_KEY = import.meta.env.VITE_CORALOGIX_PUBLIC_KEY
export const CORALOGIX_APPLICATION = import.meta.env.VITE_CORALOGIX_APPLICATION || 'Chatbot'
export const CORALOGIX_VERSION = import.meta.env.VITE_CORALOGIX_VERSION || '1.0.0'
export const CORALOGIX_DOMAIN = import.meta.env.VITE_CORALOGIX_DOMAIN || 'EU2'
export const CORALOGIX_ENVIRONMENT = import.meta.env.VITE_CORALOGIX_ENVIRONMENT || import.meta.env.MODE

export const getBaseConfig = () => ({
  public_key: CORALOGIX_PUBLIC_KEY,
  application: CORALOGIX_APPLICATION,
  version: CORALOGIX_VERSION,
  coralogixDomain: CORALOGIX_DOMAIN,
  environment: CORALOGIX_ENVIRONMENT,
})
